











import { Component, Vue } from 'vue-property-decorator';
import SearchBox from '@/components/global/header/SearchBox.vue';
import SelfUserStatus from '@/components/global/header/SelfUserStatus.vue';
import { store } from '@/utils/store';

@Component({
  components: {
    SearchBox,
    SelfUserStatus,
  },
})
export default class Header extends Vue {
  toRoom() {
    if (this.$route.name !== 'Room') this.$router.push({ name: 'Room', params: { roomId: store.roomId ?? '' } });
  }
}
